import { useEffect } from "react"
import { useLocation } from "react-router-dom"

const HEADER_OFFSET = 80

function getScrollableParent(el: HTMLElement | null): HTMLElement | null {
	let node = el?.parentElement ?? null

	while (node) {
		const style = window.getComputedStyle(node)
		const canScrollY = /(auto|scroll)/.test(style.overflowY)
		const hasScrollableContent = node.scrollHeight > node.clientHeight

		if (canScrollY && hasScrollableContent) return node
		node = node.parentElement
	}

	return null
}

export function HashScrollHandler() {
	const location = useLocation()

	useEffect(() => {
		if (!location.hash) return
		const id = decodeURIComponent(location.hash.slice(1))
		if (!id) return

		let tries = 0
		const maxTries = 40

		const tryScroll = () => {
			const el = document.getElementById(id)
			if (!el) {
				if (tries++ < maxTries) setTimeout(tryScroll, 50)
				return
			}

			const scrollParent = getScrollableParent(el)

			if (scrollParent) {
				const parentTop = scrollParent.getBoundingClientRect().top
				const elTop = el.getBoundingClientRect().top
				const nextTop =
					scrollParent.scrollTop + (elTop - parentTop) - HEADER_OFFSET

				scrollParent.scrollTo({ top: nextTop, behavior: "smooth" })
				return
			}

			el.scrollIntoView({ behavior: "smooth", block: "start" })
		}

		requestAnimationFrame(tryScroll)
	}, [location.pathname, location.hash])

	return null
}
